import {
  Box,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  Pagination,
  Switch,
  useTheme,
  Chip,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {
  CustomTableContainer,
  CustomTableHead,
  TableContentVendorFont,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import empty from "../../../assets/illo.png";
import {
  ButtonLink,
  DisplayText,
} from "../../bankDetails/components/bankAccountsContent";
import PropTypes from "prop-types";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useDispatch, useSelector } from "react-redux";
import {
  getProjects,
  removeProject,
  changeProjectStatus,
} from "../redux/projectSlice";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { history } from "../../../app/history";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Delete,
  RemoveRedEye,
} from "@mui/icons-material";
import moment from "moment";

const EmptyContainer = () => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
  >
    <br />
    <img src={empty} alt="empty" />

    <DisplayText> There are no Projects to display</DisplayText>
    <br />
    <ButtonLink to="/app/create-project">+ Add Project</ButtonLink>
    <br />

    <br />
  </Grid>
);

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <>
      <Box sx={{ flexShrink: 0 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    </>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function ProjectTableContent({ search, clicked, setClicked }) {
  const [page, setPage] = React.useState(1);
  const [per_page, setPer_page] = React.useState(10);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [actionId, setActionId] = useState(null);

  const { projectList, pagination, loading, deleteLoading, updateLoading } =
    useSelector((state) => state.project);
  console.log("projectList", projectList);
  const dispatch = useDispatch();
  const fetchList = () => {
    const payload = {
      per_page,
      page,
      search,
    };
    dispatch(getProjects(payload));
    setClicked(false);
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line
  }, [page, rowsPerPage, per_page, clicked]);

  useEffect(() => {
    setPage(1);
  }, [per_page, clicked]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDelete = (id) => {
    setActionId(id);
    dispatch(removeProject({ id })).then((res) => {
      setActionId(null);
      if (res.payload?.success) {
        fetchList();
      }
    });
  };

  const handleStatusChange = (id, currentStatus) => {
    setActionId(id);
    const newStatus = !currentStatus;
    dispatch(changeProjectStatus({ id, isActive: newStatus })).then(
      (res) => {
        setActionId(null);
        if (res.payload?.success) {
          fetchList();
        }
      },
      () => setActionId(null),
    );
  };
  const STATUS_COLOR_MAP = {
    PLANNING: "secondary",
    IN_PROGRESS: "primary",
    ON_HOLD: "warning",
    COMPLETED: "success",
    CANCELLED: "error",
  };

  return (
    <CustomTableContainer component={Card}>
      <Table aria-label="simple table">
        <CustomTableHead>
          <TableRow>
            <TableCell>
              <TableHeaderFont>S.No</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Project Name</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Project Code</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Status</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Company</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Business Unit</TableHeaderFont>
            </TableCell>

            <TableCell>
              <TableHeaderFont>Created Date</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Action</TableHeaderFont>
            </TableCell>
          </TableRow>
        </CustomTableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={9} sx={{ textAlign: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 4,
                  }}
                >
                  <CircularProgress />
                </Box>
              </TableCell>
            </TableRow>
          ) : projectList?.projects?.length > 0 ? (
            projectList?.projects?.map((project, index) => (
              <TableRow key={project?.id}>
                <TableCell>{(page - 1) * per_page + index + 1}</TableCell>
                <TableCell>{project?.project_name}</TableCell>
                <TableCell>{project?.project_code}</TableCell>
                <TableCell>
                  <Chip
                    label={
                      project?.project_status == "ON_HOLD"
                        ? "ON HOLD"
                        : project?.project_status == "IN_PROGRESS"
                        ? "IN PROGRESS"
                        : project?.project_status
                    }
                    color={
                      STATUS_COLOR_MAP[project?.project_status] || "default"
                    }
                    size="small"
                    sx={{
                      fontSize: "9px",

                      fontWeight: 600,
                    }}
                  />
                </TableCell>
                <TableCell>{project?.Company?.company_name || "-"}</TableCell>
                <TableCell>
                  {project?.businessUnit?.businessUnitName || "-"}
                </TableCell>
                <TableCell>
                  {moment(project?.createdAt).format("DD-MM-YYYY")}
                </TableCell>

                <TableCell>
                  <Box sx={{ display: "flex", gap: "10px" }}>
                    <Link to={`/app/project/view/${project?.id}`}>
                      <IconButton sx={{ p: 0.5 }}>
                        <RemoveRedEye
                          sx={{ fontSize: 18, color: "royalblue" }}
                        />
                      </IconButton>
                    </Link>
                  </Box>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={9}>
                <EmptyContainer />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ height: "10vh", borderTop: "1px solid lightgray", px: 3 }}
      >
        <Grid item sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <span>Rows per page:</span>
          <select
            value={per_page}
            onChange={(e) => {
              setPer_page(e.target.value);
              setPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </Grid>

        <Grid item>
          <Pagination
            color="primary"
            variant="text"
            onChange={(_, newValue) => setPage(newValue)}
            count={pagination?.totalPages}
            page={page}
            shape="rounded"
            showFirstButton
            showLastButton
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
      </Grid>
    </CustomTableContainer>
  );
}

export default ProjectTableContent;
